export default `
  mutation updateCardType($workflowId: ID!, $id: ID!, $input: CardTypeInput!) {
    updateCardType(workflowId: $workflowId, id: $id, input: $input) {
      workflowId
      cardTypes {
        id
        title
        description
        color {
          red
          green
          blue
          rgb
        }
        showInBacklog
        domainModelRole
        defaultType
        generateWithAI
        order
        workflowId
        createdAt
      }
    }
  }
`
